import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickIconComponent } from './tick-icon.component';



@NgModule({
  declarations: [
    TickIconComponent
  ],
  imports: [
    CommonModule
  ], 
  exports: [
    TickIconComponent
  ]
})
export class TickIconModule { }
